<p-splitButton
  *ngIf="userInfo"
  [label]="userInfo.username + ' [' + userInfo.userId + ']'"
  icon="pi pi-user"
  (onClick)="navigate()"
  [model]="items"
  styleClass="p-button-raised p-button-info"
></p-splitButton>
